export const productConstants = {
  QUESTIONS_TYPES_REQUEST: "QUESTIONS_TYPES_REQUEST",
  QUESTIONS_TYPES_SUCCESS: "QUESTIONS_TYPES_SUCCESS",
  QUESTIONS_TYPES_FAILURE: "QUESTIONS_TYPES_FAILURE",
};
